(() => {
  const applyApprovedQuizCopy = () => {
    document.querySelectorAll('[data-ss-quiz] .ss-quiz__progress-note').forEach((note) => {
      note.textContent = 'Durée totale : 1 minute';
    });
  };

  const removeDuplicateHomeH1 = () => {
    document.querySelectorAll('#header-component > h1.visually-hidden').forEach((heading) => {
      const replacement = document.createElement('span');
      replacement.className = heading.className;
      replacement.textContent = heading.textContent;
      heading.replaceWith(replacement);
    });
  };

  const bypassUnavailableEmailSave = () => {
    if (window.SecretSantaQuizEmailCapture && typeof window.SecretSantaQuizEmailCapture.submit === 'function') return;
    const visibleSave = document.querySelector('[data-ss-quiz-save]:not([hidden])');
    const skip = visibleSave?.querySelector('[data-ss-email-skip]');
    if (skip instanceof HTMLButtonElement) skip.click();
  };

  document.addEventListener('secret-santa:quiz_email_offered', bypassUnavailableEmailSave);

  const init = () => {
    applyApprovedQuizCopy();
    removeDuplicateHomeH1();

    const header = document.querySelector('#header-component');
    if (header && 'MutationObserver' in window) {
      new MutationObserver(removeDuplicateHomeH1).observe(header, { childList: true });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
